import { Container } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import { Dashboard, SvgIconComponent } from "@material-ui/icons";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BusinessIcon from "@material-ui/icons/Business";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Users from "@material-ui/icons/People";
import clsx from "clsx";
import Color from "color";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import { ROUTES } from "../constants";
import { DRAWER_WIDTH } from "../constants/style";
interface Props {}

interface DrawerItem {
  path: string;
  name: string;
  icon: SvgIconComponent;
  selected?: (route: string) => boolean;
}

const drawerItems: Array<DrawerItem> = [
  {
    path: ROUTES.DASHBOARD,
    name: "Dashboard",
    icon: Dashboard,
    selected: (route: string) => route.includes(ROUTES.DASHBOARD),
  },
  {
    path: ROUTES.COMPANIES,
    name: "Auftraggeber",
    icon: BusinessIcon,
    selected: (route: string) => route.includes(ROUTES.COMPANIES),
  },
  {
    path: ROUTES.TESTS,
    name: "Tests",
    icon: Assignment,
    selected: (route: string) =>
      route.includes(ROUTES.TESTS) || route === ROUTES.HOME,
  },
  {
    path: ROUTES.EMPLOYEES,
    name: "Testpersonendaten",
    icon: AssignmentIndIcon,
    selected: (route: string) => route.includes(ROUTES.EMPLOYEES),
  },
  {
    path: ROUTES.USERS,
    name: "Benutzer",
    icon: Users,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  drawer: {
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: DRAWER_WIDTH,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(9) + 1,
  },
  drawerPaper: {
    color: theme.palette.grey.A100,
  },
  selected: {
    color: theme.palette.primary.main,
  },
  selectedIcon: {
    backgroundColor: `${Color(theme.palette.primary.main).fade(0.8)}`,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menuText: {},
  listItem: {
    color: theme.palette.secondary.main,
  },
  container: {
    marginTop: 25,
  },
}));

const Layout: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const classes = useStyles();
  const { pathname } = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header handleDrawerOpen={handleDrawerOpen} open={open} />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(classes.drawerPaper, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          {drawerItems.map(({ path, name, icon: Icon, selected }, index) => {
            const isSelected = selected
              ? selected(pathname)
              : path === pathname;

            return (
              <div key={path || index}>
                <ListItem
                  button
                  selected={isSelected && open}
                  className={clsx(classes.listItem, {
                    [classes.selected]: isSelected,
                  })}
                  component={Link}
                  to={path}
                >
                  <ListItemIcon
                    color="secondary"
                    className={clsx({
                      [classes.selected]: isSelected,
                    })}
                  >
                    <div
                      className={clsx(
                        "MuiListItem-root",
                        classes.iconContainer,
                        {
                          [classes.selectedIcon]: isSelected && !open,
                        }
                      )}
                    >
                      <Icon color="secondary" />
                    </div>
                  </ListItemIcon>

                  <ListItemText
                    primary={name}
                    classes={{
                      primary: classes.menuText,
                    }}
                  />
                </ListItem>
              </div>
            );
          })}
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Container className={classes.container} maxWidth="xl" >
          <>{children}</>
        </Container>
      </main>
    </div>
  );
};

export default Layout;
